"use client";
/* Core */
import { createSlice } from "@reduxjs/toolkit";
import {completeJackpot, jackpotDetails, jackpotHistory, startJackpot, jackpotAmount} from "./actions";

const initialState = {
    loading: false,
    jackpotDetail: null,
    jackpotHistoryList: [],
    totalJackpotHistory: 0,
    jackpotAmountDetails : null
};

export const jackpotSlice = createSlice({
    name: "jackpotSlice",
    initialState,
    reducers: {
        setJackpotHistoryDetails(state, action) {
            const { data } = action.payload;
            state.jackpotDetail = data;
        },
        clearHistoryList(state, action) {
            state.jackpotHistoryList = [];
            state.totalJackpotHistory = 0;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(startJackpot.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(startJackpot.fulfilled, (state, action) => {
                state.loading = false;
                state.jackpotDetail = action.payload.data
            })
            .addCase(startJackpot.rejected, (state, action) => {
                state.loading = false;
            })
            .addCase(completeJackpot.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(completeJackpot.fulfilled, (state, action) => {
                state.loading = false;
                state.user = {
                    ...state.user,
                    energyBalance: action.payload.data.energyBalance,
                    btncBalance: action.payload.data.btncBalance
                }
            })
            .addCase(completeJackpot.rejected, (state, action) => {
                state.loading = false;
            })
            .addCase(jackpotHistory.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(jackpotHistory.fulfilled, (state, action) => {
                state.loading = false;
                state.jackpotHistoryList =
                    action.payload?.filter?.page === 1
                        ? action.payload.data
                        : [...state.jackpotHistoryList, ...action.payload.data];
                state.totalJackpotHistory = action.payload.totalcount;
            })
            .addCase(jackpotHistory.rejected, (state, action) => {
                state.loading = false;
            })
            .addCase(jackpotDetails.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(jackpotDetails.fulfilled, (state, action) => {
                state.loading = false;
                state.jackpotDetail = action.payload.data
            })
            .addCase(jackpotDetails.rejected, (state, action) => {
                state.loading = false;
            })
            .addCase(jackpotAmount.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(jackpotAmount.fulfilled, (state, action) => {
                state.loading = false;
                state.jackpotAmountDetails = action.payload.data
            })
            .addCase(jackpotAmount.rejected, (state, action) => {
                state.loading = false;
            })
    }
});

export default jackpotSlice.reducer;